module.exports = __webpack_public_path__ + "img/home-5-earth.70fdafc7.png";